import React, { useState, useEffect } from 'react';
import TabContainer from '../../components/TabContainer';
import PersonelListesiPage from '../hr/PersonelListesiPage';
import PuantajAylikPage from '../hr/PuantajAylikPage';
// import PuantajGunlukPage from '../hr/PuantajGunlukPage';  // şimdilik gizli — aylık özet yeterli
import IzinKaydiPage from '../hr/IzinKaydiPage';
import CiroPayiPage from '../hr/CiroPayiPage';
import IkRaporlarPage from '../hr/IkRaporlarPage';
import IkAyarlarPage from '../hr/IkAyarlarPage';
import KidemKayitlariPage from '../hr/KidemKayitlariPage';
import IkHatirlatmalarPage from '../hr/IkHatirlatmalarPage';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const IkPage = () => {
  // Faz D: ciro payı global bayrağı askıda olabilir. Bilinene kadar gizle (güvenli taraf).
  const [ciroPayiAktif, setCiroPayiAktif] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/ik/ayarlar`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setCiroPayiAktif(!!d.ciro_payi_aktif); })
      .catch(() => {});
  }, []);

  const tabs = [
    { id: 'personel', label: 'Personel Listesi', icon: '👥', component: <PersonelListesiPage /> },
    { id: 'puantaj', label: 'Aylık Puantaj', icon: '📅', component: <PuantajAylikPage /> },
    // { id: 'gunluk', label: 'Günlük Puantaj', icon: '🕒', component: <PuantajGunlukPage /> },  // gizli
    { id: 'izin', label: 'İzin Kaydı', icon: '🏖️', component: <IzinKaydiPage /> },
    { id: 'ciro-payi', label: 'Ciro Payı', icon: '💵', component: <CiroPayiPage /> },
    { id: 'kidem', label: 'Kıdem Kayıtları', icon: '📋', component: <KidemKayitlariPage /> },
    { id: 'hatirlatmalar', label: 'Hatırlatmalar', icon: '🔔', component: <IkHatirlatmalarPage /> },
    { id: 'raporlar', label: 'Raporlar', icon: '📈', component: <IkRaporlarPage /> },
    { id: 'ayarlar', label: 'Ayarlar', icon: '⚙️', component: <IkAyarlarPage /> },
  ].filter(t => t.id !== 'ciro-payi' || ciroPayiAktif);

  return <TabContainer title="İnsan Kaynakları" tabs={tabs} defaultTab="personel" />;
};

export default IkPage;
